import { createContext, Dispatch, SetStateAction } from 'react';

import { FormulaType } from '../constants/formulaType';

import { ChannelDefinition } from '../models/channelDefinition.model';
import { GenericMessagePreviewModel } from '../models/editor.model';
// models
import {
    FormulaAdditionalMetadata,
    FormulaDetailModel,
} from '../models/formula.model';
import { LabelModel } from '../models/label.model';

export interface EditorDetailsModel {
    formula: FormulaDetailModel | null;
    formulaType: FormulaType | null;
    previews: GenericMessagePreviewModel[];
    testPreviews: GenericMessagePreviewModel[];
    isPreviewError: boolean;
    previewError: string | null;
    isGenerating: boolean;
    isApproved: boolean;
    newly_created_alternate_id: string;
    selectedLabel?: LabelModel;
    isControlledFormula?: boolean;
    isSecondaryView?: boolean;
    additional_metadata?: FormulaAdditionalMetadata;
    showSmallPhone?: boolean;
    selectRandomFilters?: boolean;
    alternateMessagesCount?: number;
    // True when the formula's content is an override channel's raw v2 dict
    // rather than a Slate document - no server-side preview/validation
    // exists for this shape yet, so consumers gating on `previews` should
    // not block review/approve actions on it.
    isOverrideChannelContent?: boolean;
    // The effective channel definition, populated whenever
    // isOverrideChannelContent is true - lets consumers (e.g.
    // FormulaInfoComponent's approve/review validation) check required
    // fields directly instead of relying on a Slate-based preview sample.
    channelDefinition?: ChannelDefinition;
}

export interface MessageContentContextModel {
    isContentUpdating: boolean;
    setIsContentUpdating: (value: boolean) => void;
}

export interface EditorContextModel {
    editorDetails: EditorDetailsModel;
    setEditorDetails: Dispatch<SetStateAction<EditorDetailsModel>>;
}

export const defaultEditorDetails: EditorDetailsModel = {
    formula: null,
    formulaType: null,
    previews: [],
    testPreviews: [],
    isPreviewError: false,
    previewError: null,
    isGenerating: false,
    isApproved: false,
    newly_created_alternate_id: '',
    selectedLabel: undefined,
    isControlledFormula: false,
    isSecondaryView: false,
    showSmallPhone: false,
    selectRandomFilters: false,
    alternateMessagesCount: 0,
    isOverrideChannelContent: false,
};

export const EditorContext = createContext<EditorContextModel>({
    editorDetails: defaultEditorDetails,
    setEditorDetails: () => {},
});

export const MessageContentContext = createContext<MessageContentContextModel>({
    isContentUpdating: false,
    setIsContentUpdating: () => {},
});
